import NprService from './service';
import { AddNprRequest, AddNprResponseData, UpdateNprRequestData } from './types';
import { getAppStore } from '@src/utils/store-reference';
import { RequestStatus, RequestType, StorageScopes } from '@src/utils/enums';
import { useApp, useJpa } from '@stores';
import { queryClient } from '@src/api/queryClient';
import { PROJECT_QUERY_KEYS } from '@src/api/services/project';

export class NprMutations {
  public static readonly addNpr = async (payload: AddNprRequest): Promise<AddNprResponseData> => {
    const store = getAppStore();
    const { resetToDefaults } = useJpa.getState();
    const { setIsLoading } = useApp.getState();

    resetToDefaults();

    setIsLoading(true, `Loading ${RequestType.ActivityBasedNoPermitRequired} Form`);

    const { data } = await NprService.addNpr(payload);

    store.doUpdateRequestAPIData({
      projectID: data.projectID,
      projectVersion: data.projectVersion,
      request: { requestID: data.requestID, permission: data.permission },
    });
    store.doUpdateRequestData({
      projectID: data.projectID,
      projectVersion: data.projectVersion,
      request: { requestID: data.requestID },
    });

    useJpa.setState({ jpaBasicInfo: data?.jpaBasicInfo });

    store.doUpdateRequestObject({
      requestStatus: RequestStatus.Draft,
      requestType: RequestType.ActivityBasedNoPermitRequired,
      requestID: data.requestID,
    });
    queryClient.invalidateQueries({
      queryKey: [
        PROJECT_QUERY_KEYS.GET_SHARED_CONTACTS,
        store.selectProjectID(),
        store.selectRequestID(),
        store.selectVersion(),
      ],
    });
    store.doUpdateNprRequest({ noPermitRequiredID: data.noPermitRequiredID });
    store.doFetchUserFilesDetails({ componentID: data.noPermitRequiredID, scope: StorageScopes.ProjectFolder });
    setIsLoading(false);
    return data;
  };
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public static readonly updateNpr = async (payload: any): Promise<UpdateNprRequestData> => {
    const { data } = await NprService.updateNpr(payload);

    return data;
  };
}
